var path = 'C:/Projects/repos/NAERS-Web/src/components/app/common/app-toolbar/app-toolbar.html';
var html = "<md-toolbar id=page-header class=md-hue-2> <div class=md-toolbar-tools> <div ng-transclude=toolbarButtonsLeft></div> <span class=md-truncate>NAERS<sup>&trade;</sup> NASC Adverse Event Reporting System</span> <span flex></span> <div ng-transclude=toolbarButtonsRight></div> </div> </md-toolbar>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./components/app/common/app-toolbar/app-toolbar.html
// module id = 575
// module chunks = 0